import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type MiscellaneousFeesFilters = {
  user_id: number | null;
  notAppliedFees: boolean;
};

type MiscellaneousFeesState = {
  filters: MiscellaneousFeesFilters;
};

const initialState: MiscellaneousFeesState = {
  filters: {
    user_id: null,
    notAppliedFees: true
  }
};

const miscellaneousFeesSlice = createSlice({
  name: 'miscellaneousFees',
  initialState,
  reducers: {
    setMiscFeesFilters(state, action: PayloadAction<Partial<MiscellaneousFeesFilters>>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetMiscFeesFilters() {
      return initialState;
    }
  }
});

export const { setMiscFeesFilters, resetMiscFeesFilters } = miscellaneousFeesSlice.actions;
export default miscellaneousFeesSlice;
